/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  MonthPlanStateIncomeTypeDto,
  MonthPlanStateIncomeTypeDtoFromJSON,
  MonthPlanStateIncomeTypeDtoFromJSONTyped,
  MonthPlanStateIncomeTypeDtoToJSON,
} from "./MonthPlanStateIncomeTypeDto";
import {
  MonthPlanStateWeekItemDto,
  MonthPlanStateWeekItemDtoFromJSON,
  MonthPlanStateWeekItemDtoFromJSONTyped,
  MonthPlanStateWeekItemDtoToJSON,
} from "./MonthPlanStateWeekItemDto";

/**
 *
 * @export
 * @interface MonthPlanStateIncomeDto
 */
export interface MonthPlanStateIncomeDto {
  /**
   *
   * @type {string}
   * @memberof MonthPlanStateIncomeDto
   */
  id: string;
  /**
   *
   * @type {MonthPlanStateIncomeTypeDto}
   * @memberof MonthPlanStateIncomeDto
   */
  incomeType: MonthPlanStateIncomeTypeDto;
  /**
   *
   * @type {number}
   * @memberof MonthPlanStateIncomeDto
   */
  plan: number;
  /**
   *
   * @type {number}
   * @memberof MonthPlanStateIncomeDto
   */
  fact: number;
  /**
   *
   * @type {Array<MonthPlanStateWeekItemDto>}
   * @memberof MonthPlanStateIncomeDto
   */
  weeks: Array<MonthPlanStateWeekItemDto>;
}

export function MonthPlanStateIncomeDtoFromJSON(json: any): MonthPlanStateIncomeDto {
  return MonthPlanStateIncomeDtoFromJSONTyped(json, false);
}

export function MonthPlanStateIncomeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonthPlanStateIncomeDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    incomeType: MonthPlanStateIncomeTypeDtoFromJSON(json["incomeType"]),
    plan: json["plan"],
    fact: json["fact"],
    weeks: (json["weeks"] as Array<any>).map(MonthPlanStateWeekItemDtoFromJSON),
  };
}

export function MonthPlanStateIncomeDtoToJSON(value?: MonthPlanStateIncomeDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    incomeType: MonthPlanStateIncomeTypeDtoToJSON(value.incomeType),
    plan: value.plan,
    fact: value.fact,
    weeks: (value.weeks as Array<any>).map(MonthPlanStateWeekItemDtoToJSON),
  };
}
